/*
 *
 * Communications actions
 *
 */

import {
  FLUSH_STATE_COMMUNICATIONS,
  INITIAL_ID,
  // load items list
  LOAD_COMMUNICATIONS,
  LOAD_COMMUNICATIONS_SUCCESS,
  LOAD_COMMUNICATIONS_ERROR,
  // load single item
  LOAD_COMMUNICATION,
  LOAD_COMMUNICATION_SUCCESS,
  LOAD_COMMUNICATION_ERROR,
  // load single item answers
  LOAD_COMMUNICATION_ANSWERS,
  LOAD_COMMUNICATION_ANSWERS_SUCCESS,
  LOAD_COMMUNICATION_ANSWERS_ERROR,
  // update single item answers
  UPDATE_COMMUNICATION_ANSWERS,
  UPDATE_COMMUNICATION_ANSWERS_SUCCESS,
  UPDATE_COMMUNICATION_ANSWERS_ERROR,
  // update item
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_SUCCESS,
  UPDATE_COMMUNICATION_ERROR,
  // delete item
  HARD_DELETE_COMMUNICATION,
  HARD_DELETE_COMMUNICATION_SUCCESS,
  HARD_DELETE_COMMUNICATION_ERROR,
  // copy item
  COPY_COMMUNICATION,
  COPY_COMMUNICATION_SUCCESS,
  COPY_COMMUNICATION_ERROR,
  // create audience from communication
  CREATE_AUDIENSE,
  CREATE_AUDIENSE_SUCCESS,
  CREATE_AUDIENSE_ERROR,
  // Reminder
  REMIND_COMMUNICATION,
  REMIND_COMMUNICATION_SUCCESS,
  REMIND_COMMUNICATION_ERROR,
  // Update ACtive Communication
  UPDATE_ACTIVE_COMMUNICATION
} from './constants';

/**
 * Clearing the state for Communications
 */
export function flushStateCommunications() {
  return {
    type: FLUSH_STATE_COMMUNICATIONS,
  };
}

/**
 * Main ID for detail commponents
 */
export function setInitialID(initialID) {
  return {
    type: INITIAL_ID,
    initialID,
  };
}

export function updateActiveElement(activeElement, actionType = 'read') {
  return {
    type: UPDATE_ACTIVE_COMMUNICATION,
    activeElement,
    actionType,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Communications, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_COMMUNICATIONS
 */
export function loadCommunications(params, firstRender = false, pages = 1) {
  return {
    type: LOAD_COMMUNICATIONS,
    params,
    firstRender,
    pages,
  };
}

/**
 * Dispatched when the loadCommunications are loaded by the request saga
 *
 * @param  {array} variables true for Communications
 *
 * @return {array} An action object with a type of LOAD_COMMUNICATIONS_SUCCESS passing the variables
 */
export function loadCommunicationsSuccess(allData, itemsList, params) {
  return {
    type: LOAD_COMMUNICATIONS_SUCCESS,
    allData,
    itemsList,
    params,
  };
}

/**
 * Dispatched when loading the loadCommunications fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_COMMUNICATIONS_ERROR passing the error
 */
export function loadCommunicationsError(error) {
  return {
    type: LOAD_COMMUNICATIONS_ERROR,
    error,
  };
}

/**
 * Load the communication, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_COMMUNICATION */

export function loadCommunication(detailID) {
  return {
    type: LOAD_COMMUNICATION,
    detailID,
  };
}

/**
 * Dispatched when the loadCommunication are loaded by the request saga
 *
 * @param  {array} Communication true for communication
 *
 * @return {object}      An action object with a type of LOAD_COMMUNICATION_SUCCESS passing the communication */

export function loadCommunicationSuccess(itemDetail) {
  return {
    type: LOAD_COMMUNICATION_SUCCESS,
    itemDetail,
  };
}

/**
 * Dispatched when loading the loadCommunication fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_COMMUNICATION_ERROR passing the error */

export function loadCommunicationError(errorDetail) {
  return {
    type: LOAD_COMMUNICATION_ERROR,
    errorDetail,
  };
}

/**
 * Load the communication ANSWERS, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_COMMUNICATION_ANSWERS */

export function loadCommunicationAnswers(detailID) {
  return {
    type: LOAD_COMMUNICATION_ANSWERS,
    detailID,
  };
}

/**
 * Dispatched when the loadCommunicationAnswers are loaded by the request saga
 *
 * @param  {object} Communication answers for communication
 *
 * @return {object}      An action object with a type of LOAD_COMMUNICATION_ANSWERS_SUCCESS passing the communication */

export function loadCommunicationAnswersSuccess(answers) {
  return {
    type: LOAD_COMMUNICATION_ANSWERS_SUCCESS,
    answers,
  };
}

/**
 * Dispatched when loading the loadCommunicationAnswers fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_COMMUNICATION_ANSWERS_ERROR passing the error */

export function loadCommunicationAnswersError(errorAnswers) {
  return {
    type: LOAD_COMMUNICATION_ANSWERS_ERROR,
    errorAnswers,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the Communications, this action starts the request saga
 *
 * @return {array} An action object with a type of UPDATE_COMMUNICATIONS
 */
export function changeCommunication(itemDetail) {
  return {
    type: UPDATE_COMMUNICATION,
    itemDetail,
  };
}

/**
 * Dispatched when the changeCommunications are changed/updated by the request saga
 *
 * @param  {array} itemDetail true for Communications
 *
 * @return {array} An action object with a type of UPDATE_COMMUNICATION_SUCCESS passing the variables
 */
export function changeCommunicationSuccess(itemDetail) {
  return {
    type: UPDATE_COMMUNICATION_SUCCESS,
    itemDetail,
  };
}

/**
 * Dispatched when loading the changeCommunications fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of UPDATE_COMMUNICATION_ERROR passing the error
 */
export function changeCommunicationError(errorUpdate) {
  return {
    type: UPDATE_COMMUNICATION_ERROR,
    errorUpdate,
  };
}

/**
 * Change/Update the Communications Answers, this action starts the request saga
 *
 * @return {planArray} An action object with a type of UPDATE_COMMUNICATION_ANSWERS
 */
export function changeCommunicationAnswers(
  planArray,
  actionType = 'save',
  commID,
  answerType = 'appointments',
) {
  return {
    type: UPDATE_COMMUNICATION_ANSWERS,
    planArray,
    actionType,
    answerType,
    commID,
  };
}

/**
 * Dispatched when the changeCommunicationAnswers are changed/updated by the request saga
 *
 * @param  {object} planData true for Communications
 *
 * @return {array} An action object with a type of UPDATE_COMMUNICATION_ANSWERS_SUCCESS passing the variables
 */
export function changeCommunicationAnswersSuccess(planData) {
  return {
    type: UPDATE_COMMUNICATION_ANSWERS_SUCCESS,
    planData,
  };
}

/**
 * Dispatched when loading the changeCommunicationAnswers fails
 *
 * @param  {object} errorPlan The error
 *
 * @return {object} An action object with a type of UPDATE_COMMUNICATION_ANSWERS_ERROR passing the error
 */
export function changeCommunicationAnswersError(errorPlan) {
  return {
    type: UPDATE_COMMUNICATION_ANSWERS_ERROR,
    errorPlan,
  };
}

/**
 * ------------------ HARD DELETE ------------------
 */

// Hard Delete for Single Item
export function hardDeleteCommunication(hardDeleteId) {
  return {
    type: HARD_DELETE_COMMUNICATION,
    hardDeleteId,
  };
}
export function hardDeleteCommunicationSuccess(hardDeleteDetail, hardDeleteId) {
  return {
    type: HARD_DELETE_COMMUNICATION_SUCCESS,
    hardDeleteDetail,
    hardDeleteId,
  };
}

export function hardDeleteCommunicationError(hardDeleteError) {
  return {
    type: HARD_DELETE_COMMUNICATION_ERROR,
    hardDeleteError,
  };
}

/**
 * ------------------ COPY ------------------
 */

/**
 * Copy the communication, this action starts the request saga
 *
 * @return {object} An action object with a type of COPY_COMMUNICATIONS */

export function copyCommunication(toCopyID) {
  return {
    type: COPY_COMMUNICATION,
    toCopyID,
  };
}

/**
 * Dispatched when the copyCommunication are loaded by the request saga
 *
 * @param  {array} Communication true for communication
 *
 * @return {object}      An action object with a type of COPY_COMMUNICATION_SUCCESS passing the communication */

export function copyCommunicationSuccess(itemDetail) {
  return {
    type: COPY_COMMUNICATION_SUCCESS,
    itemDetail,
  };
}

/**
 * Dispatched when loading the copyCommunication fails
 *
 * @param  {object} copyError The error
 *
 * @return {object}       An action object with a type of COPY_COMMUNICATION_ERROR passing the error */

export function copyCommunicationError(copyError) {
  return {
    type: COPY_COMMUNICATION_ERROR,
    copyError,
  };
}